module.exports = __webpack_public_path__ + "static/media/navy.b87637b0.png";